function $e922cc0798bf621c$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $83bc9cc15ff7c4f0$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $0cc92da550cc78a4$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $83bc9cc15ff7c4f0$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $e922cc0798bf621c$export$71511d61b312f219)(receiver, descriptor);
}


function $c5bc05a2ac451bfa$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $a154af16019e0256$export$71511d61b312f219(obj, privateMap, value) {
    (0, $c5bc05a2ac451bfa$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $bbdedb4fcfd7f199$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $6f269ea8a3166898$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $83bc9cc15ff7c4f0$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $bbdedb4fcfd7f199$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $66d4d131fdba4d15$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $846618d552d129a9$export$71511d61b312f219(obj, privateSet) {
    (0, $c5bc05a2ac451bfa$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $005f6f791aabbfae$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $093f4b8a6f2eb0fa$var$extendStatics = function(d, b) {
    $093f4b8a6f2eb0fa$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $093f4b8a6f2eb0fa$var$extendStatics(d, b);
};
function $093f4b8a6f2eb0fa$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $093f4b8a6f2eb0fa$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $093f4b8a6f2eb0fa$export$18ce0697a983be9b = function() {
    $093f4b8a6f2eb0fa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $093f4b8a6f2eb0fa$export$18ce0697a983be9b.apply(this, arguments);
};
function $093f4b8a6f2eb0fa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $093f4b8a6f2eb0fa$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $093f4b8a6f2eb0fa$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $093f4b8a6f2eb0fa$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $093f4b8a6f2eb0fa$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $093f4b8a6f2eb0fa$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $093f4b8a6f2eb0fa$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $093f4b8a6f2eb0fa$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $093f4b8a6f2eb0fa$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $093f4b8a6f2eb0fa$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $093f4b8a6f2eb0fa$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $093f4b8a6f2eb0fa$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $093f4b8a6f2eb0fa$export$45d3717a4c69092e(o, m, p);
}
function $093f4b8a6f2eb0fa$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $093f4b8a6f2eb0fa$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $093f4b8a6f2eb0fa$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($093f4b8a6f2eb0fa$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $093f4b8a6f2eb0fa$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $093f4b8a6f2eb0fa$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $093f4b8a6f2eb0fa$export$10c90e4f7922046c(v) {
    return this instanceof $093f4b8a6f2eb0fa$export$10c90e4f7922046c ? (this.v = v, this) : new $093f4b8a6f2eb0fa$export$10c90e4f7922046c(v);
}
function $093f4b8a6f2eb0fa$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $093f4b8a6f2eb0fa$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $093f4b8a6f2eb0fa$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $093f4b8a6f2eb0fa$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $093f4b8a6f2eb0fa$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $093f4b8a6f2eb0fa$export$19a8beecd37a4c45 === "function" ? $093f4b8a6f2eb0fa$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $093f4b8a6f2eb0fa$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $093f4b8a6f2eb0fa$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $093f4b8a6f2eb0fa$var$ownKeys = function(o) {
    $093f4b8a6f2eb0fa$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $093f4b8a6f2eb0fa$var$ownKeys(o);
};
function $093f4b8a6f2eb0fa$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $093f4b8a6f2eb0fa$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $093f4b8a6f2eb0fa$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $093f4b8a6f2eb0fa$var$__setModuleDefault(result, mod);
    return result;
}
function $093f4b8a6f2eb0fa$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $093f4b8a6f2eb0fa$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $093f4b8a6f2eb0fa$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $093f4b8a6f2eb0fa$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $093f4b8a6f2eb0fa$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $093f4b8a6f2eb0fa$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $093f4b8a6f2eb0fa$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $093f4b8a6f2eb0fa$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $093f4b8a6f2eb0fa$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $093f4b8a6f2eb0fa$export$2e2bcd8739ae039 = {
    __extends: $093f4b8a6f2eb0fa$export$a8ba968b8961cb8a,
    __assign: $093f4b8a6f2eb0fa$export$18ce0697a983be9b,
    __rest: $093f4b8a6f2eb0fa$export$3c9a16f847548506,
    __decorate: $093f4b8a6f2eb0fa$export$29e00dfd3077644b,
    __param: $093f4b8a6f2eb0fa$export$d5ad3fd78186038f,
    __esDecorate: $093f4b8a6f2eb0fa$export$3a84e1ae4e97e9b0,
    __runInitializers: $093f4b8a6f2eb0fa$export$d831c04e792af3d,
    __propKey: $093f4b8a6f2eb0fa$export$6a2a36740a146cb8,
    __setFunctionName: $093f4b8a6f2eb0fa$export$d1a06452d3489bc7,
    __metadata: $093f4b8a6f2eb0fa$export$f1db080c865becb9,
    __awaiter: $093f4b8a6f2eb0fa$export$1050f835b63b671e,
    __generator: $093f4b8a6f2eb0fa$export$67ebef60e6f28a6,
    __createBinding: $093f4b8a6f2eb0fa$export$45d3717a4c69092e,
    __exportStar: $093f4b8a6f2eb0fa$export$f33643c0debef087,
    __values: $093f4b8a6f2eb0fa$export$19a8beecd37a4c45,
    __read: $093f4b8a6f2eb0fa$export$8d051b38c9118094,
    __spread: $093f4b8a6f2eb0fa$export$afc72e2116322959,
    __spreadArrays: $093f4b8a6f2eb0fa$export$6388937ca91ccae8,
    __spreadArray: $093f4b8a6f2eb0fa$export$1216008129fb82ed,
    __await: $093f4b8a6f2eb0fa$export$10c90e4f7922046c,
    __asyncGenerator: $093f4b8a6f2eb0fa$export$e427f37a30a4de9b,
    __asyncDelegator: $093f4b8a6f2eb0fa$export$bbd80228419bb833,
    __asyncValues: $093f4b8a6f2eb0fa$export$e3b29a3d6162315f,
    __makeTemplateObject: $093f4b8a6f2eb0fa$export$4fb47efe1390b86f,
    __importStar: $093f4b8a6f2eb0fa$export$c21735bcef00d192,
    __importDefault: $093f4b8a6f2eb0fa$export$da59b14a69baef04,
    __classPrivateFieldGet: $093f4b8a6f2eb0fa$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $093f4b8a6f2eb0fa$export$d40a35129aaff81f,
    __classPrivateFieldIn: $093f4b8a6f2eb0fa$export$81fdc39f203e4e04,
    __addDisposableResource: $093f4b8a6f2eb0fa$export$88ac25d8e944e405,
    __disposeResources: $093f4b8a6f2eb0fa$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $093f4b8a6f2eb0fa$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $68a6104730858551$var$t = globalThis, $68a6104730858551$export$b4d10f6001c083c2 = $68a6104730858551$var$t.ShadowRoot && (void 0 === $68a6104730858551$var$t.ShadyCSS || $68a6104730858551$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $68a6104730858551$var$s = Symbol(), $68a6104730858551$var$o = new WeakMap;
class $68a6104730858551$export$505d1e8739bad805 {
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($68a6104730858551$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $68a6104730858551$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $68a6104730858551$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $68a6104730858551$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
}
const $68a6104730858551$export$8d80f9cac07cdb3 = (t)=>new $68a6104730858551$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $68a6104730858551$var$s), $68a6104730858551$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $68a6104730858551$export$505d1e8739bad805(o, t, $68a6104730858551$var$s);
}, $68a6104730858551$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($68a6104730858551$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $68a6104730858551$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $68a6104730858551$export$ee69dfd951e24778 = $68a6104730858551$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $68a6104730858551$export$8d80f9cac07cdb3(e);
    })(t) : t;


var $682f8011832b9670$var$_Symbol, $682f8011832b9670$var$_a, $682f8011832b9670$var$_a1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $682f8011832b9670$var$i, defineProperty: $682f8011832b9670$var$e, getOwnPropertyDescriptor: $682f8011832b9670$var$h, getOwnPropertyNames: $682f8011832b9670$var$r, getOwnPropertySymbols: $682f8011832b9670$var$o, getPrototypeOf: $682f8011832b9670$var$n } = Object, $682f8011832b9670$var$a = globalThis, $682f8011832b9670$var$c = $682f8011832b9670$var$a.trustedTypes, $682f8011832b9670$var$l = $682f8011832b9670$var$c ? $682f8011832b9670$var$c.emptyScript : "", $682f8011832b9670$var$p = $682f8011832b9670$var$a.reactiveElementPolyfillSupport, $682f8011832b9670$var$d = (t, s)=>t, $682f8011832b9670$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $682f8011832b9670$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $682f8011832b9670$export$53a6892c50694894 = (t, s)=>!$682f8011832b9670$var$i(t, s), $682f8011832b9670$var$b = {
    attribute: !0,
    type: String,
    converter: $682f8011832b9670$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $682f8011832b9670$export$53a6892c50694894
};
var $682f8011832b9670$var$_metadata, $682f8011832b9670$var$_litPropertyMetadata;
($682f8011832b9670$var$_metadata = ($682f8011832b9670$var$_Symbol = Symbol).metadata) !== null && $682f8011832b9670$var$_metadata !== void 0 ? $682f8011832b9670$var$_metadata : $682f8011832b9670$var$_Symbol.metadata = Symbol("metadata"), ($682f8011832b9670$var$_litPropertyMetadata = ($682f8011832b9670$var$_a = $682f8011832b9670$var$a).litPropertyMetadata) !== null && $682f8011832b9670$var$_litPropertyMetadata !== void 0 ? $682f8011832b9670$var$_litPropertyMetadata : $682f8011832b9670$var$_a.litPropertyMetadata = new WeakMap;
class $682f8011832b9670$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        var _this_l;
        this._$Ei(), ((_this_l = this.l) !== null && _this_l !== void 0 ? _this_l : this.l = []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $682f8011832b9670$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $682f8011832b9670$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        var _h;
        const { get: e, set: r } = (_h = $682f8011832b9670$var$h(this.prototype, t)) !== null && _h !== void 0 ? _h : {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e === null || e === void 0 ? void 0 : e.call(this);
                r === null || r === void 0 ? void 0 : r.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        var _this_elementProperties_get;
        return (_this_elementProperties_get = this.elementProperties.get(t)) !== null && _this_elementProperties_get !== void 0 ? _this_elementProperties_get : $682f8011832b9670$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($682f8011832b9670$var$d("elementProperties"))) return;
        const t = $682f8011832b9670$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($682f8011832b9670$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($682f8011832b9670$var$d("properties"))) {
            const t = this.properties, s = [
                ...$682f8011832b9670$var$r(t),
                ...$682f8011832b9670$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $68a6104730858551$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $68a6104730858551$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Ev() {
        var _this_constructor_l;
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), (_this_constructor_l = this.constructor.l) === null || _this_constructor_l === void 0 ? void 0 : _this_constructor_l.forEach((t)=>t(this));
    }
    addController(t) {
        var _t_hostConnected;
        var _this__$EO;
        ((_this__$EO = this._$EO) !== null && _this__$EO !== void 0 ? _this__$EO : this._$EO = new Set).add(t), void 0 !== this.renderRoot && this.isConnected && ((_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t));
    }
    removeController(t) {
        var _this__$EO;
        (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        var _this_shadowRoot;
        const t = (_this_shadowRoot = this.shadowRoot) !== null && _this_shadowRoot !== void 0 ? _this_shadowRoot : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $68a6104730858551$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        var _this__$EO;
        var _this_renderRoot;
        (_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this.enableUpdating(!0), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach((t)=>{
            var _t_hostConnected;
            return (_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var _this__$EO;
        (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach((t)=>{
            var _t_hostDisconnected;
            return (_t_hostDisconnected = t.hostDisconnected) === null || _t_hostDisconnected === void 0 ? void 0 : _t_hostDisconnected.call(t);
        });
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            var _i_converter;
            const h = (void 0 !== ((_i_converter = i.converter) === null || _i_converter === void 0 ? void 0 : _i_converter.toAttribute) ? i.converter : $682f8011832b9670$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            var _t_converter, _this__$Ej;
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== ((_t_converter = t.converter) === null || _t_converter === void 0 ? void 0 : _t_converter.fromAttribute) ? t.converter : $682f8011832b9670$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            var _ref;
            this[e] = (_ref = r !== null && r !== void 0 ? r : (_this__$Ej = this._$Ej) === null || _this__$Ej === void 0 ? void 0 : _this__$Ej.get(e)) !== null && _ref !== void 0 ? _ref : r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            var _this__$Ej;
            const r = this.constructor;
            var _i_hasChanged;
            if (!1 === e && (h = this[t]), i !== null && i !== void 0 ? i : i = r.getPropertyOptions(t), !(((_i_hasChanged = i.hasChanged) !== null && _i_hasChanged !== void 0 ? _i_hasChanged : $682f8011832b9670$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === ((_this__$Ej = this._$Ej) === null || _this__$Ej === void 0 ? void 0 : _this__$Ej.get(t)) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        var _this__$Ej, _ref, _this__$Eq;
        i && !((_this__$Ej = this._$Ej) !== null && _this__$Ej !== void 0 ? _this__$Ej : this._$Ej = new Map).has(t) && (this._$Ej.set(t, (_ref = r !== null && r !== void 0 ? r : s) !== null && _ref !== void 0 ? _ref : this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && ((_this__$Eq = this._$Eq) !== null && _this__$Eq !== void 0 ? _this__$Eq : this._$Eq = new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            var _this_renderRoot;
            if ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            var _this__$EO;
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach((t)=>{
                var _t_hostUpdate;
                return (_t_hostUpdate = t.hostUpdate) === null || _t_hostUpdate === void 0 ? void 0 : _t_hostUpdate.call(t);
            }), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var _this__$EO;
        (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach((t)=>{
            var _t_hostUpdated;
            return (_t_hostUpdated = t.hostUpdated) === null || _t_hostUpdated === void 0 ? void 0 : _t_hostUpdated.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq && (this._$Eq = this._$Eq.forEach((t)=>this._$ET(t, this[t]))), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
}
var $682f8011832b9670$var$_reactiveElementVersions;
$682f8011832b9670$export$c7c07a37856565d.elementStyles = [], $682f8011832b9670$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $682f8011832b9670$export$c7c07a37856565d[$682f8011832b9670$var$d("elementProperties")] = new Map, $682f8011832b9670$export$c7c07a37856565d[$682f8011832b9670$var$d("finalized")] = new Map, $682f8011832b9670$var$p === null || $682f8011832b9670$var$p === void 0 ? void 0 : $682f8011832b9670$var$p({
    ReactiveElement: $682f8011832b9670$export$c7c07a37856565d
}), (($682f8011832b9670$var$_reactiveElementVersions = ($682f8011832b9670$var$_a1 = $682f8011832b9670$var$a).reactiveElementVersions) !== null && $682f8011832b9670$var$_reactiveElementVersions !== void 0 ? $682f8011832b9670$var$_reactiveElementVersions : $682f8011832b9670$var$_a1.reactiveElementVersions = []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $51c9baf7a95ff46c$var$_t;
const $51c9baf7a95ff46c$var$t = globalThis, $51c9baf7a95ff46c$var$i = (t)=>t, $51c9baf7a95ff46c$var$s = $51c9baf7a95ff46c$var$t.trustedTypes, $51c9baf7a95ff46c$var$e = $51c9baf7a95ff46c$var$s ? $51c9baf7a95ff46c$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $51c9baf7a95ff46c$var$h = "$lit$", $51c9baf7a95ff46c$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $51c9baf7a95ff46c$var$n = "?" + $51c9baf7a95ff46c$var$o, $51c9baf7a95ff46c$var$r = `<${$51c9baf7a95ff46c$var$n}>`, $51c9baf7a95ff46c$var$l = document, $51c9baf7a95ff46c$var$c = ()=>$51c9baf7a95ff46c$var$l.createComment(""), $51c9baf7a95ff46c$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $51c9baf7a95ff46c$var$u = Array.isArray, $51c9baf7a95ff46c$var$d = (t)=>$51c9baf7a95ff46c$var$u(t) || "function" == typeof (t === null || t === void 0 ? void 0 : t[Symbol.iterator]), $51c9baf7a95ff46c$var$f = "[ \t\n\f\r]", $51c9baf7a95ff46c$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $51c9baf7a95ff46c$var$_ = /-->/g, $51c9baf7a95ff46c$var$m = />/g, $51c9baf7a95ff46c$var$p = RegExp(`>|${$51c9baf7a95ff46c$var$f}(?:([^\\s"'>=/]+)(${$51c9baf7a95ff46c$var$f}*=${$51c9baf7a95ff46c$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $51c9baf7a95ff46c$var$g = /'/g, $51c9baf7a95ff46c$var$$ = /"/g, $51c9baf7a95ff46c$var$y = /^(?:script|style|textarea|title)$/i, $51c9baf7a95ff46c$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $51c9baf7a95ff46c$export$c0bb0b647f701bb5 = $51c9baf7a95ff46c$var$x(1), $51c9baf7a95ff46c$export$7ed1367e7fa1ad68 = $51c9baf7a95ff46c$var$x(2), $51c9baf7a95ff46c$export$47d5b44d225be5b4 = $51c9baf7a95ff46c$var$x(3), $51c9baf7a95ff46c$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $51c9baf7a95ff46c$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $51c9baf7a95ff46c$var$C = new WeakMap, $51c9baf7a95ff46c$var$P = $51c9baf7a95ff46c$var$l.createTreeWalker($51c9baf7a95ff46c$var$l, 129);
function $51c9baf7a95ff46c$var$V(t, i) {
    if (!$51c9baf7a95ff46c$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $51c9baf7a95ff46c$var$e ? $51c9baf7a95ff46c$var$e.createHTML(i) : i;
}
const $51c9baf7a95ff46c$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $51c9baf7a95ff46c$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $51c9baf7a95ff46c$var$v ? "!--" === u[1] ? c = $51c9baf7a95ff46c$var$_ : void 0 !== u[1] ? c = $51c9baf7a95ff46c$var$m : void 0 !== u[2] ? ($51c9baf7a95ff46c$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $51c9baf7a95ff46c$var$p) : void 0 !== u[3] && (c = $51c9baf7a95ff46c$var$p) : c === $51c9baf7a95ff46c$var$p ? ">" === u[0] ? (c = n !== null && n !== void 0 ? n : $51c9baf7a95ff46c$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $51c9baf7a95ff46c$var$p : '"' === u[3] ? $51c9baf7a95ff46c$var$$ : $51c9baf7a95ff46c$var$g) : c === $51c9baf7a95ff46c$var$$ || c === $51c9baf7a95ff46c$var$g ? c = $51c9baf7a95ff46c$var$p : c === $51c9baf7a95ff46c$var$_ || c === $51c9baf7a95ff46c$var$m ? c = $51c9baf7a95ff46c$var$v : (c = $51c9baf7a95ff46c$var$p, n = void 0);
        const x = c === $51c9baf7a95ff46c$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $51c9baf7a95ff46c$var$v ? s + $51c9baf7a95ff46c$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $51c9baf7a95ff46c$var$h + s.slice(d) + $51c9baf7a95ff46c$var$o + x) : s + $51c9baf7a95ff46c$var$o + (-2 === d ? i : x);
    }
    return [
        $51c9baf7a95ff46c$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $51c9baf7a95ff46c$var$S {
    static createElement(t, i) {
        const s = $51c9baf7a95ff46c$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $51c9baf7a95ff46c$var$N(t, i);
        if (this.el = $51c9baf7a95ff46c$var$S.createElement(f, e), $51c9baf7a95ff46c$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $51c9baf7a95ff46c$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($51c9baf7a95ff46c$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($51c9baf7a95ff46c$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $51c9baf7a95ff46c$var$I : "?" === e[1] ? $51c9baf7a95ff46c$var$L : "@" === e[1] ? $51c9baf7a95ff46c$var$z : $51c9baf7a95ff46c$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($51c9baf7a95ff46c$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($51c9baf7a95ff46c$var$y.test(r.tagName)) {
                    const t = r.textContent.split($51c9baf7a95ff46c$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $51c9baf7a95ff46c$var$s ? $51c9baf7a95ff46c$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $51c9baf7a95ff46c$var$c()), $51c9baf7a95ff46c$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $51c9baf7a95ff46c$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $51c9baf7a95ff46c$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($51c9baf7a95ff46c$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $51c9baf7a95ff46c$var$o.length - 1;
                }
            }
            l++;
        }
    }
}
function $51c9baf7a95ff46c$var$M(t, i, s = t, e) {
    var _s__$Co, _h__$AO;
    var _s;
    if (i === $51c9baf7a95ff46c$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? (_s__$Co = s._$Co) === null || _s__$Co === void 0 ? void 0 : _s__$Co[e] : s._$Cl;
    const o = $51c9baf7a95ff46c$var$a(i) ? void 0 : i._$litDirective$;
    var __$Co;
    return (h === null || h === void 0 ? void 0 : h.constructor) !== o && (h === null || h === void 0 ? void 0 : (_h__$AO = h._$AO) === null || _h__$AO === void 0 ? void 0 : _h__$AO.call(h, !1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? ((__$Co = (_s = s)._$Co) !== null && __$Co !== void 0 ? __$Co : _s._$Co = [])[e] = h : s._$Cl = h), void 0 !== h && (i = $51c9baf7a95ff46c$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $51c9baf7a95ff46c$var$R {
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var _t_creationScope;
        const { el: { content: i }, parts: s } = this._$AD, e = ((_t_creationScope = t === null || t === void 0 ? void 0 : t.creationScope) !== null && _t_creationScope !== void 0 ? _t_creationScope : $51c9baf7a95ff46c$var$l).importNode(i, !0);
        $51c9baf7a95ff46c$var$P.currentNode = e;
        let h = $51c9baf7a95ff46c$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $51c9baf7a95ff46c$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $51c9baf7a95ff46c$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== (r === null || r === void 0 ? void 0 : r.index) && (h = $51c9baf7a95ff46c$var$P.nextNode(), o++);
        }
        return $51c9baf7a95ff46c$var$P.currentNode = $51c9baf7a95ff46c$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
}
class $51c9baf7a95ff46c$var$k {
    get _$AU() {
        var _this__$AM;
        var _this__$AM__$AU;
        return (_this__$AM__$AU = (_this__$AM = this._$AM) === null || _this__$AM === void 0 ? void 0 : _this__$AM._$AU) !== null && _this__$AM__$AU !== void 0 ? _this__$AM__$AU : this._$Cv;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (t === null || t === void 0 ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $51c9baf7a95ff46c$var$M(this, t, i), $51c9baf7a95ff46c$var$a(t) ? t === $51c9baf7a95ff46c$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $51c9baf7a95ff46c$export$45b790e32b2810ee && this._$AR(), this._$AH = $51c9baf7a95ff46c$export$45b790e32b2810ee) : t !== this._$AH && t !== $51c9baf7a95ff46c$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $51c9baf7a95ff46c$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $51c9baf7a95ff46c$export$45b790e32b2810ee && $51c9baf7a95ff46c$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($51c9baf7a95ff46c$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        var _this__$AH;
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $51c9baf7a95ff46c$var$S.createElement($51c9baf7a95ff46c$var$V(s.h, s.h[0]), this.options)), s);
        if (((_this__$AH = this._$AH) === null || _this__$AH === void 0 ? void 0 : _this__$AH._$AD) === e) this._$AH.p(i);
        else {
            const t = new $51c9baf7a95ff46c$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $51c9baf7a95ff46c$var$C.get(t.strings);
        return void 0 === i && $51c9baf7a95ff46c$var$C.set(t.strings, i = new $51c9baf7a95ff46c$var$S(t)), i;
    }
    k(t) {
        $51c9baf7a95ff46c$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $51c9baf7a95ff46c$var$k(this.O($51c9baf7a95ff46c$var$c()), this.O($51c9baf7a95ff46c$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        var _this__$AP, _this;
        for((_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, !1, !0, s); t !== this._$AB;){
            const s = $51c9baf7a95ff46c$var$i(t).nextSibling;
            $51c9baf7a95ff46c$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        var _this__$AP, _this;
        void 0 === this._$AM && (this._$Cv = t, (_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, t));
    }
    constructor(t, i, s, e){
        var _e_isConnected;
        this.type = 2, this._$AH = $51c9baf7a95ff46c$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = (_e_isConnected = e === null || e === void 0 ? void 0 : e.isConnected) !== null && _e_isConnected !== void 0 ? _e_isConnected : !0;
    }
}
class $51c9baf7a95ff46c$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $51c9baf7a95ff46c$var$M(this, t, i, 0), o = !$51c9baf7a95ff46c$var$a(t) || t !== this._$AH && t !== $51c9baf7a95ff46c$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $51c9baf7a95ff46c$var$M(this, e[s + n], i, n), r === $51c9baf7a95ff46c$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o || (o = !$51c9baf7a95ff46c$var$a(r) || r !== this._$AH[n]), r === $51c9baf7a95ff46c$export$45b790e32b2810ee ? t = $51c9baf7a95ff46c$export$45b790e32b2810ee : t !== $51c9baf7a95ff46c$export$45b790e32b2810ee && (t += (r !== null && r !== void 0 ? r : "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $51c9baf7a95ff46c$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t !== null && t !== void 0 ? t : "");
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $51c9baf7a95ff46c$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $51c9baf7a95ff46c$export$45b790e32b2810ee;
    }
}
class $51c9baf7a95ff46c$var$I extends $51c9baf7a95ff46c$var$H {
    j(t) {
        this.element[this.name] = t === $51c9baf7a95ff46c$export$45b790e32b2810ee ? void 0 : t;
    }
    constructor(){
        super(...arguments), this.type = 3;
    }
}
class $51c9baf7a95ff46c$var$L extends $51c9baf7a95ff46c$var$H {
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $51c9baf7a95ff46c$export$45b790e32b2810ee);
    }
    constructor(){
        super(...arguments), this.type = 4;
    }
}
class $51c9baf7a95ff46c$var$z extends $51c9baf7a95ff46c$var$H {
    _$AI(t, i = this) {
        var _M;
        if ((t = (_M = $51c9baf7a95ff46c$var$M(this, t, i, 0)) !== null && _M !== void 0 ? _M : $51c9baf7a95ff46c$export$45b790e32b2810ee) === $51c9baf7a95ff46c$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $51c9baf7a95ff46c$export$45b790e32b2810ee && s !== $51c9baf7a95ff46c$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $51c9baf7a95ff46c$export$45b790e32b2810ee && (s === $51c9baf7a95ff46c$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var _this_options;
        var _this_options_host;
        "function" == typeof this._$AH ? this._$AH.call((_this_options_host = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.host) !== null && _this_options_host !== void 0 ? _this_options_host : this.element, t) : this._$AH.handleEvent(t);
    }
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
}
class $51c9baf7a95ff46c$var$Z {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $51c9baf7a95ff46c$var$M(this, t);
    }
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
}
const $51c9baf7a95ff46c$export$8613d1ca9052b22e = {
    M: $51c9baf7a95ff46c$var$h,
    P: $51c9baf7a95ff46c$var$o,
    A: $51c9baf7a95ff46c$var$n,
    C: 1,
    L: $51c9baf7a95ff46c$var$N,
    R: $51c9baf7a95ff46c$var$R,
    D: $51c9baf7a95ff46c$var$d,
    V: $51c9baf7a95ff46c$var$M,
    I: $51c9baf7a95ff46c$var$k,
    H: $51c9baf7a95ff46c$var$H,
    N: $51c9baf7a95ff46c$var$L,
    U: $51c9baf7a95ff46c$var$z,
    B: $51c9baf7a95ff46c$var$I,
    F: $51c9baf7a95ff46c$var$Z
}, $51c9baf7a95ff46c$var$B = $51c9baf7a95ff46c$var$t.litHtmlPolyfillSupport;
var $51c9baf7a95ff46c$var$_litHtmlVersions;
$51c9baf7a95ff46c$var$B === null || $51c9baf7a95ff46c$var$B === void 0 ? void 0 : $51c9baf7a95ff46c$var$B($51c9baf7a95ff46c$var$S, $51c9baf7a95ff46c$var$k), (($51c9baf7a95ff46c$var$_litHtmlVersions = ($51c9baf7a95ff46c$var$_t = $51c9baf7a95ff46c$var$t).litHtmlVersions) !== null && $51c9baf7a95ff46c$var$_litHtmlVersions !== void 0 ? $51c9baf7a95ff46c$var$_litHtmlVersions : $51c9baf7a95ff46c$var$_t.litHtmlVersions = []).push("3.3.2");
const $51c9baf7a95ff46c$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var _s_renderBefore;
    const e = (_s_renderBefore = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore !== void 0 ? _s_renderBefore : i;
    let h = e._$litPart$;
    if (void 0 === h) {
        var _s_renderBefore1;
        const t = (_s_renderBefore1 = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore1 !== void 0 ? _s_renderBefore1 : null;
        e._$litPart$ = h = new $51c9baf7a95ff46c$var$k(i.insertBefore($51c9baf7a95ff46c$var$c(), t), t, void 0, s !== null && s !== void 0 ? s : {});
    }
    return h._$AI(t), h;
};




var $0630cf70b06a1baf$var$_s_litElementHydrateSupport;
var $0630cf70b06a1baf$var$_s;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0630cf70b06a1baf$var$s = globalThis;
class $0630cf70b06a1baf$export$3f2f9f5909897157 extends (0, $682f8011832b9670$export$c7c07a37856565d) {
    createRenderRoot() {
        var _this_renderOptions;
        const t = super.createRenderRoot();
        var _renderBefore;
        return (_renderBefore = (_this_renderOptions = this.renderOptions).renderBefore) !== null && _renderBefore !== void 0 ? _renderBefore : _this_renderOptions.renderBefore = t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $51c9baf7a95ff46c$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var _this__$Do;
        super.connectedCallback(), (_this__$Do = this._$Do) === null || _this__$Do === void 0 ? void 0 : _this__$Do.setConnected(!0);
    }
    disconnectedCallback() {
        var _this__$Do;
        super.disconnectedCallback(), (_this__$Do = this._$Do) === null || _this__$Do === void 0 ? void 0 : _this__$Do.setConnected(!1);
    }
    render() {
        return 0, $51c9baf7a95ff46c$export$9c068ae9cc5db4e8;
    }
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
}
$0630cf70b06a1baf$export$3f2f9f5909897157._$litElement$ = !0, $0630cf70b06a1baf$export$3f2f9f5909897157["finalized"] = !0, ($0630cf70b06a1baf$var$_s_litElementHydrateSupport = $0630cf70b06a1baf$var$s.litElementHydrateSupport) === null || $0630cf70b06a1baf$var$_s_litElementHydrateSupport === void 0 ? void 0 : $0630cf70b06a1baf$var$_s_litElementHydrateSupport.call($0630cf70b06a1baf$var$s, {
    LitElement: $0630cf70b06a1baf$export$3f2f9f5909897157
});
const $0630cf70b06a1baf$var$o = $0630cf70b06a1baf$var$s.litElementPolyfillSupport;
$0630cf70b06a1baf$var$o === null || $0630cf70b06a1baf$var$o === void 0 ? void 0 : $0630cf70b06a1baf$var$o({
    LitElement: $0630cf70b06a1baf$export$3f2f9f5909897157
});
const $0630cf70b06a1baf$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
var $0630cf70b06a1baf$var$_litElementVersions;
(($0630cf70b06a1baf$var$_litElementVersions = ($0630cf70b06a1baf$var$_s = $0630cf70b06a1baf$var$s).litElementVersions) !== null && $0630cf70b06a1baf$var$_litElementVersions !== void 0 ? $0630cf70b06a1baf$var$_litElementVersions : $0630cf70b06a1baf$var$_s.litElementVersions = []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $263dd3d053ba4061$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $166ccf76ba20334a$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a94cbe2d74cf14dd$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $682f8011832b9670$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $682f8011832b9670$export$53a6892c50694894)
}, $a94cbe2d74cf14dd$export$8d623b1670eb40f4 = (t = $a94cbe2d74cf14dd$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $a94cbe2d74cf14dd$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $a94cbe2d74cf14dd$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



function $f035f824b8d80c67$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $005f6f791aabbfae$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $3dc21cb15f533760$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3dc21cb15f533760$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $3dc21cb15f533760$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3d3952e2a8e169ee$export$ca000e230c0caa3e(r) {
    return (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)((0, $3dc21cb15f533760$export$71511d61b312f219)((0, $f035f824b8d80c67$export$71511d61b312f219)({}, r), {
        state: !0,
        attribute: !1
    }));
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $918a40d9b7306ef6$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc3312fe3c43ee5b$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3e00b4096387b4f1$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>{
            var _t_renderRoot;
            var _t_renderRoot_querySelector;
            return (_t_renderRoot_querySelector = (_t_renderRoot = t.renderRoot) === null || _t_renderRoot === void 0 ? void 0 : _t_renderRoot.querySelector(e)) !== null && _t_renderRoot_querySelector !== void 0 ? _t_renderRoot_querySelector : null;
        };
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i !== null && i !== void 0 ? i : (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $f6b6b66d64d603d8$var$e;
function $f6b6b66d64d603d8$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(n, o, {
            get () {
                var _this_renderRoot;
                return ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : $f6b6b66d64d603d8$var$e !== null && $f6b6b66d64d603d8$var$e !== void 0 ? $f6b6b66d64d603d8$var$e : $f6b6b66d64d603d8$var$e = document.createDocumentFragment()).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7b5afffead601158$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(n, e, {
            async get () {
                var _this_renderRoot;
                var _this_renderRoot_querySelector;
                return await this.updateComplete, (_this_renderRoot_querySelector = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(r)) !== null && _this_renderRoot_querySelector !== void 0 ? _this_renderRoot_querySelector : null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a6d3cf48e80f2a2b$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o !== null && o !== void 0 ? o : {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(e, n, {
            get () {
                var _this_renderRoot;
                var _t_assignedElements;
                const t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(c), e = (_t_assignedElements = t === null || t === void 0 ? void 0 : t.assignedElements(o)) !== null && _t_assignedElements !== void 0 ? _t_assignedElements : [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4c7104e0f5be5b54$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n !== null && n !== void 0 ? n : {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $cc3312fe3c43ee5b$export$51987bb50e1f6752)(o, r, {
            get () {
                var _this_renderRoot;
                const t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(s);
                var _t_assignedNodes;
                return (_t_assignedNodes = t === null || t === void 0 ? void 0 : t.assignedNodes(n)) !== null && _t_assignedNodes !== void 0 ? _t_assignedNodes : [];
            }
        });
    };
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e3625c71d6a69f6b$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $e3625c71d6a69f6b$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $e3625c71d6a69f6b$export$befdefbdce210f91 {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
    constructor(t){}
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $983243d90e880b2a$export$56cc687933817664 = (0, $e3625c71d6a69f6b$export$99b43ad1ed32e735)(class extends (0, $e3625c71d6a69f6b$export$befdefbdce210f91) {
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            var _this_nt;
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !((_this_nt = this.nt) === null || _this_nt === void 0 ? void 0 : _this_nt.has(t)) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            var _this_nt1;
            const s = !!i[t];
            s === this.st.has(t) || ((_this_nt1 = this.nt) === null || _this_nt1 === void 0 ? void 0 : _this_nt1.has(t)) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $51c9baf7a95ff46c$export$9c068ae9cc5db4e8;
    }
    constructor(t){
        var _t_strings;
        if (super(t), t.type !== (0, $e3625c71d6a69f6b$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || ((_t_strings = t.strings) === null || _t_strings === void 0 ? void 0 : _t_strings.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
});





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $10c1d9bf57ad39a4$export$f68dd208b5df064d = (o)=>o !== null && o !== void 0 ? o : (0, $51c9baf7a95ff46c$export$45b790e32b2810ee);










var $d48c7d8215aebc14$var$__class;
const $d48c7d8215aebc14$var$LAYOUTS_SPACING = {
    "layouts": {
        "ge-layout-form": {
            "max-width": "1440px"
        }
    }
};
var $d48c7d8215aebc14$export$2e2bcd8739ae039 = $d48c7d8215aebc14$var$LAYOUTS_SPACING;
function $d48c7d8215aebc14$var$applyLayoutSpacing(element, layoutKey, cssVarPrefix, componentName) {
    const values = $d48c7d8215aebc14$var$LAYOUTS_SPACING.layouts[layoutKey] || null;
    if (values && !("max-width" in values)) console.warn(`${componentName}: layout "${layoutKey}" ne d\xe9finit pas de max-width, valeur par d\xe9faut appliqu\xe9e.`);
    var _values_maxwidth;
    const maxWidth = (_values_maxwidth = values === null || values === void 0 ? void 0 : values["max-width"]) !== null && _values_maxwidth !== void 0 ? _values_maxwidth : "100%";
    element.style.setProperty(`${cssVarPrefix}max-width`, maxWidth);
    return !!values;
}
var $d48c7d8215aebc14$var$_class;
const $d48c7d8215aebc14$export$40802ce1100d71a = (superClass)=>($d48c7d8215aebc14$var$_class = ($d48c7d8215aebc14$var$__class = class _class extends superClass {
        connectedCallback() {
            super.connectedCallback();
            for (const prop of [
                "layoutKey",
                '_hasLayout'
            ])if (Object.prototype.hasOwnProperty.call(this, prop)) {
                const val = this[prop];
                delete this[prop];
                this[prop] = val;
            }
        }
        willUpdate(changed) {
            super.willUpdate(changed);
            if (changed.has("layoutKey")) {
                const prefix = `--${this.tagName.toLowerCase().replace('ge-', '')}-`;
                this._hasLayout = $d48c7d8215aebc14$var$applyLayoutSpacing(this, this.layoutKey, prefix);
            }
        }
        getMaxWidthClasses(baseClass) {
            return {
                [baseClass]: true,
                "maxwidth-full": this._isFullWidth && !this._hasLayout,
                "maxwidth-formulaire": !this._isFullWidth && !this._hasLayout,
                "maxwidth-from-layout": this._hasLayout
            };
        }
        constructor(){
            super(), (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "_hasLayout", false);
            this.layoutKey = null;
        }
    }, (0, $005f6f791aabbfae$export$71511d61b312f219)($d48c7d8215aebc14$var$__class, "properties", (0, $3dc21cb15f533760$export$71511d61b312f219)((0, $f035f824b8d80c67$export$71511d61b312f219)({}, superClass.properties), {
        layoutKey: {
            type: String
        }
    })), $d48c7d8215aebc14$var$__class), (0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
        (0, $3d3952e2a8e169ee$export$ca000e230c0caa3e)()
    ], $d48c7d8215aebc14$var$_class.prototype, "_hasLayout", void 0), $d48c7d8215aebc14$var$_class);


let $48fb85aacf243585$var$_ = (t)=>t, $48fb85aacf243585$var$t, $48fb85aacf243585$var$t1, $48fb85aacf243585$var$t2, $48fb85aacf243585$var$t3, $48fb85aacf243585$var$t4, $48fb85aacf243585$var$t5, $48fb85aacf243585$var$t6, $48fb85aacf243585$var$t7, $48fb85aacf243585$var$t8, $48fb85aacf243585$var$t9;
const $48fb85aacf243585$var$TRANSLATIONS = {
    fr: {
        contact: "Contact",
        accessibility: "Accessibilit\xe9",
        privacy: "Politique de confidentialit\xe9",
        terms: "Conditions g\xe9n\xe9rales",
        sitemapLabel: "Plan du site",
        footerLinksLabel: "Liens de bas de page"
    },
    en: {
        contact: "Contact",
        accessibility: "Accessibility",
        privacy: "Privacy Policy",
        terms: "Terms and Conditions",
        sitemapLabel: "Site map",
        footerLinksLabel: "Footer links"
    },
    es: {
        contact: "Contacto",
        accessibility: "Accesibilidad",
        privacy: "Pol\xedtica de privacidad",
        terms: "Condiciones generales",
        sitemapLabel: "Mapa del sitio",
        footerLinksLabel: "Enlaces de pie de p\xe1gina"
    },
    pt: {
        contact: "Contacto",
        accessibility: "Acessibilidade",
        privacy: "Pol\xedtica de privacidade",
        terms: "Termos e condi\xe7\xf5es",
        sitemapLabel: "Mapa do site",
        footerLinksLabel: "Liga\xe7\xf5es de rodap\xe9"
    }
};
var $48fb85aacf243585$var$_LayoutAwareMixin, $48fb85aacf243585$var$_localeValue = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_langObserver = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_resolvedLang = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_resolvedTheme = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_systemTheme = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_mediaQuery = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_userSetTheme = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_onSystemThemeChange = /*#__PURE__*/ new WeakMap(), $48fb85aacf243585$var$_resolvedLinks = /*#__PURE__*/ new WeakMap(), /**
     * Renders one site-map node as an `<li>`: a link (or a plain `<span>`
     * label when the node has no `href`) plus a nested `<ul>` for its children.
     * Links are removed from the Tab order (`tabindex="-1"`) since the whole
     * landmark is visually hidden — screen readers still reach them, but
     * sighted keyboard users never focus an invisible element.
     */ $48fb85aacf243585$var$_renderSitemapNode = /*#__PURE__*/ new WeakSet(), $48fb85aacf243585$var$_onImageClick = /*#__PURE__*/ new WeakSet();
/**
 * Pied de page des sites de l'État de Genève.
 *
 * @fires ge-footer-image-click - Clic sur les armoiries du footer. detail: { originalEvent: MouseEvent }
 */ class $48fb85aacf243585$export$43ba67831782a95 extends ($48fb85aacf243585$var$_LayoutAwareMixin = (0, $d48c7d8215aebc14$export$40802ce1100d71a)((0, $0630cf70b06a1baf$export$3f2f9f5909897157))) {
    /**
     * Effective full-width state. The new `fullWidth` boolean takes precedence,
     * but legacy `maxWidth="false"` still works for backward compat.
     */ get _isFullWidth() {
        if (this.maxWidth === "false") return false;
        return this.fullWidth === "true";
    }
    /** Override language for footer labels. If not set, inherits from nearest ancestor [lang] attribute, defaults to 'fr'. */ get locale() {
        return (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_localeValue);
    }
    set locale(value) {
        const oldValue = (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_localeValue);
        (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_localeValue, value || undefined);
        this.requestUpdate('locale', oldValue);
    }
    /** Theme: 'light' or 'dark'. Defaults to system preference, attribute overrides. */ get theme() {
        return (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme);
    }
    set theme(value) {
        const oldValue = (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme);
        if (value) {
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme, value);
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme, true);
        } else {
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme, false);
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme, (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme));
        }
        this.requestUpdate('theme', oldValue);
    }
    updated(changed) {
        super.updated(changed);
        if (changed.has('maxWidth') && this.maxWidth !== 'true') console.warn("ge-footer: maxwidth attribute is deprecated. Use the fullWidth boolean property instead. Example: <ge-footer .fullWidth=${false}>");
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme, window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
        if (!this.hasAttribute("theme")) {
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme, (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme));
            (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme, false);
        } else (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme, true);
        (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_mediaQuery, window.matchMedia("(prefers-color-scheme: dark)"));
        (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_mediaQuery).addEventListener("change", (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_onSystemThemeChange));
        (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_langObserver, new MutationObserver(()=>{
            if (!this.locale) this.requestUpdate();
        }));
        (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_langObserver).observe(document.documentElement, {
            attributes: true,
            attributeFilter: [
                'lang'
            ]
        });
    }
    disconnectedCallback() {
        var _class_private_field_get1, _class_private_field_get2;
        super.disconnectedCallback();
        (_class_private_field_get1 = (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_mediaQuery)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.removeEventListener("change", (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_onSystemThemeChange));
        (_class_private_field_get2 = (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_langObserver)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.disconnect();
    }
    render() {
        const containerClasses = this.getMaxWidthClasses("footer");
        const t5 = $48fb85aacf243585$var$TRANSLATIONS[(0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedLang)] || $48fb85aacf243585$var$TRANSLATIONS.fr;
        const hasSitemap = Array.isArray(this.sitemap) && this.sitemap.length > 0;
        return (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t4 || ($48fb85aacf243585$var$t4 = $48fb85aacf243585$var$_`
            <footer>
                ${0}
                <div id="ge-footer" class=${0}>
                    <nav aria-label="${0}">
                        ${0}
                    </nav>
                    <img
                            id="ge-footer-armoiries"
                            src="https://static.app.ge.ch/theme/icons/common/footer/footer-armoiries-${0}.svg"
                            alt="Armoiries de la République et canton de Genève"
                            height="54"
                            @click="${0}"
                    />
                </div>
            </footer>
        `), hasSitemap ? (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t1 || ($48fb85aacf243585$var$t1 = $48fb85aacf243585$var$_`
                    <nav class="visually-hidden" aria-label="${0}">
                        ${0}
                    </nav>
                `), t5.sitemapLabel, this.sitemap.map((section)=>{
            var _section_links;
            return (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t || ($48fb85aacf243585$var$t = $48fb85aacf243585$var$_`
                            <h2>${0}</h2>
                            <ul>
                                ${0}
                            </ul>
                        `), section.title, ((_section_links = section.links) !== null && _section_links !== void 0 ? _section_links : []).map((node)=>(0, $66d4d131fdba4d15$export$71511d61b312f219)(this, $48fb85aacf243585$var$_renderSitemapNode, $48fb85aacf243585$var$renderSitemapNode).call(this, node)));
        })) : (0, $51c9baf7a95ff46c$export$45b790e32b2810ee), (0, $983243d90e880b2a$export$56cc687933817664)(containerClasses), t5.footerLinksLabel, (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedLinks).map((link, index)=>(0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t3 || ($48fb85aacf243585$var$t3 = $48fb85aacf243585$var$_`
                            ${0}
                            <a
                                href="${0}"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-ge-track=${0}
                            >${0}</a>
                        `), index > 0 ? (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t2 || ($48fb85aacf243585$var$t2 = $48fb85aacf243585$var$_`<span aria-hidden="true">|</span>`)) : null, link.href, (0, $10c1d9bf57ad39a4$export$f68dd208b5df064d)(link.id), link.title)), this.theme, (0, $66d4d131fdba4d15$export$71511d61b312f219)(this, $48fb85aacf243585$var$_onImageClick, $48fb85aacf243585$var$onImageClick));
    }
    constructor(){
        super(), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedLang, {
            get: $48fb85aacf243585$var$get_resolvedLang,
            set: void 0
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedLinks, {
            get: $48fb85aacf243585$var$get_resolvedLinks,
            set: void 0
        }), (0, $846618d552d129a9$export$71511d61b312f219)(this, $48fb85aacf243585$var$_renderSitemapNode), (0, $846618d552d129a9$export$71511d61b312f219)(this, $48fb85aacf243585$var$_onImageClick), /**
     * @deprecated Use `fullWidth` instead.
     * @type {"true"|"false"}
     */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "maxWidth", "true"), /**
     * When `"true"`, footer spans full width. When `"false"`, constrained to 1107px.
     * @type {"true"|"false"}
     */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "fullWidth", "true"), /** URL for the Contact link */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "contactLink", "https://www.ge.ch/c/footer-edm-aide"), /** URL for the Accessibility link */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "accessibilityLink", "https://www.ge.ch/c/footer-edm-accessibilite"), /** URL for the Privacy Policy link */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "privacyLink", "https://www.ge.ch/c/footer-edm-confidentialite"), /** URL for the Terms link */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "termsLink", "https://www.ge.ch/c/footer-edm-cgu"), /**
     * Custom links array. Overrides default links when provided.
     * Each entry accepts `{ title, href }` plus an optional `id`, exposed as
     * `data-ge-track` so analytics can identify the link independently of its URL.
     */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "links", void 0), /**
     * Optional site map ("plan du site"). When provided, renders a
     * screen-reader-only navigation landmark (visually hidden, exposed to
     * assistive tech) so users can navigate the whole site structure from the
     * footer. Each section is an `<h2>` heading followed by a nested list of
     * links; nodes may nest via `children`. The footer's visible appearance is
     * unchanged. Accepts a JSON string attribute or an array property.
     * @type {import("./ge-footer").FooterSitemapSection[]}
     */ (0, $005f6f791aabbfae$export$71511d61b312f219)(this, "sitemap", void 0), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_localeValue, {
            writable: true,
            value: void 0
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_langObserver, {
            writable: true,
            value: void 0
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme, {
            writable: true,
            value: 'light'
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme, {
            writable: true,
            value: 'light'
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_mediaQuery, {
            writable: true,
            value: void 0
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme, {
            writable: true,
            value: false
        }), (0, $a154af16019e0256$export$71511d61b312f219)(this, $48fb85aacf243585$var$_onSystemThemeChange, {
            writable: true,
            value: ()=>{
                (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme, window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
                if (!(0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_userSetTheme)) {
                    const oldValue = (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme);
                    (0, $6f269ea8a3166898$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedTheme, (0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_systemTheme));
                    this.requestUpdate('theme', oldValue);
                }
            }
        });
        // SWC transpiles class fields into instance properties that shadow
        // Lit's reactive prototype accessors. Delete them so Lit's setters work.
        const reactiveProps = [
            'maxWidth',
            'fullWidth',
            'contactLink',
            'accessibilityLink',
            'privacyLink',
            'termsLink',
            'links',
            'sitemap'
        ];
        for (const prop of reactiveProps)if (Object.prototype.hasOwnProperty.call(this, prop)) {
            const val = this[prop];
            delete this[prop];
            this[prop] = val;
        }
    }
}
(0, $005f6f791aabbfae$export$71511d61b312f219)($48fb85aacf243585$export$43ba67831782a95, "styles", (0, $68a6104730858551$export$dbf350e5966cf602)($48fb85aacf243585$var$t5 || ($48fb85aacf243585$var$t5 = $48fb85aacf243585$var$_`
        :host {
            display: block;
            grid-area: footer;
            font-family: 'Roboto', Arial, Helvetica, sans-serif;
        }

        footer {
            background: var(--md-sys-color-surface);
            border-top: 1px solid var(--md-sys-color-outline-variant);
        }

        #ge-footer {
            transition: max-width 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 74px;
            padding: 0 32px;
            margin: auto;
        }

        #ge-footer hr {
            border-color: var(--md-sys-color-outline-variant);
            border-style: solid;
            border-bottom: none;
            border-width: 1px;
            width: calc(100% - 16px);
            margin: 4px 0 8px 0;
            display: none;
        }

        #ge-footer > nav {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-right: 20px;
        }

        #ge-footer > nav > a {
            color: var(--md-sys-color-on-surface-variant);
            font-family: 'Roboto', var(--md-ref-typeface-brand), Arial, Helvetica, sans-serif;
            font-size: var(--md-sys-typescale-body-medium-size, 14px);
            font-style: normal;
            line-height: var(--md-sys-typescale-body-medium-line-height, 20px);
            letter-spacing: var(--md-sys-typescale-body-medium-tracking, 0.25px);
            font-weight: 400;
            text-decoration: none;
        }

        #ge-footer > nav > span {
            color: var(--md-sys-color-outline-variant);
        }

        #ge-footer > nav > a:hover {
            color: var(--md-sys-color-primary);
        }

        #ge-footer > nav > a:focus-visible {
            outline: 2px solid var(--md-sys-color-primary);
            outline-offset: 2px;
            border-radius: 2px;
        }

        #ge-footer-armoiries {
            cursor: pointer;
        }

        @media (max-width: 768px) {
            #ge-footer {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: var(--md-ref-spacings-8, 32px);
                height: 278px;
                padding: var(--md-ref-spacings-8, 32px) var(--md-ref-spacings-4, 16px);
            }

            #ge-footer > nav {
                flex-direction: column;
                align-items: flex-start;
                gap: var(--md-ref-spacings-5, 20px);
                margin-right: 0;
            }

            #ge-footer > nav > span {
                display: none;
            }

            #ge-footer-armoiries {
                margin-top: 0;
            }

            #ge-footer hr {
                display: block;
            }
        }

        #ge-footer.maxwidth-formulaire {
            max-width: 1107px;
        }

        #ge-footer.maxwidth-full {
            max-width: 100%;
        }
        
        #ge-footer.maxwidth-from-layout {
            max-width: var(--footer-max-width);
        }

        /* Screen-reader-only: keeps content in the accessibility tree while
           removing it visually (clip technique, not display:none). */
        .visually-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }
    `)));
function $48fb85aacf243585$var$get_resolvedLang() {
    var _this_closest;
    if (this.locale) return this.locale;
    const lang = (_this_closest = this.closest('[lang]')) === null || _this_closest === void 0 ? void 0 : _this_closest.lang;
    return lang ? lang.split('-')[0] : 'fr';
}
function $48fb85aacf243585$var$get_resolvedLinks() {
    var _this_links;
    if ((_this_links = this.links) === null || _this_links === void 0 ? void 0 : _this_links.length) return this.links;
    const t = $48fb85aacf243585$var$TRANSLATIONS[(0, $0cc92da550cc78a4$export$71511d61b312f219)(this, $48fb85aacf243585$var$_resolvedLang)] || $48fb85aacf243585$var$TRANSLATIONS.fr;
    // `id` identifie le lien indépendamment de son URL (configurable par
    // application) et de sa langue — voir `data-ge-track` dans render().
    return [
        {
            id: "footer:contact",
            title: t.contact,
            href: this.contactLink
        },
        {
            id: "footer:accessibility",
            title: t.accessibility,
            href: this.accessibilityLink
        },
        {
            id: "footer:privacy",
            title: t.privacy,
            href: this.privacyLink
        },
        {
            id: "footer:terms",
            title: t.terms,
            href: this.termsLink
        }
    ];
}
function $48fb85aacf243585$var$renderSitemapNode(node) {
    const hasChildren = Array.isArray(node.children) && node.children.length > 0;
    const link = node.href ? (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t6 || ($48fb85aacf243585$var$t6 = $48fb85aacf243585$var$_`<a
                    href="${0}"
                    tabindex="-1"
                    target=${0}
                    rel=${0}
                >${0}</a>`), node.href, (0, $10c1d9bf57ad39a4$export$f68dd208b5df064d)(node.target), node.target === "_blank" ? "noopener noreferrer" : (0, $51c9baf7a95ff46c$export$45b790e32b2810ee), node.title) : (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t7 || ($48fb85aacf243585$var$t7 = $48fb85aacf243585$var$_`<span>${0}</span>`), node.title);
    return (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t9 || ($48fb85aacf243585$var$t9 = $48fb85aacf243585$var$_`
            <li>
                ${0}
                ${0}
            </li>
        `), link, hasChildren ? (0, $51c9baf7a95ff46c$export$c0bb0b647f701bb5)($48fb85aacf243585$var$t8 || ($48fb85aacf243585$var$t8 = $48fb85aacf243585$var$_`<ul>${0}</ul>`), node.children.map((child)=>(0, $66d4d131fdba4d15$export$71511d61b312f219)(this, $48fb85aacf243585$var$_renderSitemapNode, $48fb85aacf243585$var$renderSitemapNode).call(this, child))) : (0, $51c9baf7a95ff46c$export$45b790e32b2810ee));
}
function $48fb85aacf243585$var$onImageClick(e) {
    this.dispatchEvent(new CustomEvent("ge-footer-image-click", {
        detail: {
            originalEvent: e
        },
        bubbles: true,
        composed: true
    }));
}
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String,
        attribute: 'maxwidth'
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "maxWidth", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String,
        attribute: 'fullwidth'
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "fullWidth", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "contactLink", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "accessibilityLink", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "privacyLink", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "termsLink", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        attribute: "links",
        converter: {
            fromAttribute: (value)=>{
                if (!value) return undefined;
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return undefined;
                }
            }
        }
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "links", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        attribute: "sitemap",
        converter: {
            fromAttribute: (value)=>{
                if (!value) return undefined;
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return undefined;
                }
            }
        }
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "sitemap", void 0);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String,
        attribute: 'locale'
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "locale", null);
(0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $a94cbe2d74cf14dd$export$d541bacb2bda4494)({
        type: String,
        reflect: true,
        attribute: 'theme'
    })
], $48fb85aacf243585$export$43ba67831782a95.prototype, "theme", null);
$48fb85aacf243585$export$43ba67831782a95 = (0, $093f4b8a6f2eb0fa$export$29e00dfd3077644b)([
    (0, $166ccf76ba20334a$export$da64fc29f17f9d0e)("ge-footer")
], $48fb85aacf243585$export$43ba67831782a95);


//# sourceMappingURL=static.35fb4e25.js.map
